import { useSelector } from "react-redux";
import axios, { AxiosError, AxiosResponse } from "axios";
import { Trip } from "../objects/trip";
import { TravelerGroup } from "../objects/travelerGroup";
import { AppState } from "../../../reducers";

type Callback = (trip: Trip, ids: number[]) => Promise<void>

type Options = {
    onTrigger: () => void,
    onSuccess: (group: TravelerGroup) => void,
    onError: (error: AxiosError) => void,
    onFinally: () => void
}

export function useTripTravelersGroupCreate(options: Options): Callback {
    const clientId = useSelector((state: AppState) => state.header.client_id);

    return async (trip, ids) => {
        if (clientId !== null) {
            try {
                options.onTrigger();
                const response = await makeRequest(clientId, trip, ids);
                options.onSuccess(response.data);
            } catch (error: any) {
                options.onError(error);
            } finally {
                options.onFinally();
            }
        }
    };
}

function makeRequest(
    clientId: number,
    trip: Trip,
    ids: number[]
): Promise<AxiosResponse<TravelerGroup>> {
    return axios.post(
        `${API_HREF}client/${clientId}/trip/${trip.id}/versions/${trip.current_version}/travelers-group/`,
        {
            travelers: ids,
            default: true
        },
        {
            headers: {
                'Authorization': `Token ${localStorage.getItem('token')}`,
            },
        }
    );
}